import axios from "src/lib/axios";

// Get collections list
export const getCollectionsList = async (params = {}) => {
  try {
    const response = await axios.get(`/collections`, {
      params: {
        keyword: params.keyword || "",
        page: params.page || 0,
        pageSize: params.pageSize || 25,
        status: params.status || "all",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching collections:", error);
    throw error;
  }
};

// Get collection by ID
export const getCollectionById = async (id) => {
  const response = await axios.get(`/collections/detail/${id}`);
  return response.data;
};

// Create new collection
export const createCollection = async (data) => {
  return axios.post(`/collections`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Update collection
export const updateCollection = async (data) => {
  return axios.patch(`/collections`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Delete collection
export const deleteCollection = async (id) => {
  try {
    const response = await axios.delete(`/collections/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting collection:", error);
    throw error;
  }
};

// Get products for collection selection
export const getProductsForCollection = async (params = {}) => {
  try {
    const response = await axios.get(`/products`, {
      params: {
        keyword: params.keyword || "",
        page: params.page || 0,
        pageSize: params.pageSize || 50,
        status: "active",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

// Add products to collection
export const addProductsToCollection = async (collectionId, productIds) => {
  try {
    const response = await axios.post(`/collections/${collectionId}/products`, {
      productIds,
    });
    return response.data;
  } catch (error) {
    console.error("Error adding products to collection:", error);
    throw error;
  }
};

// Remove products from collection
export const removeProductsFromCollection = async (
  collectionId,
  productIds,
) => {
  try {
    const response = await axios.delete(
      `/collections/${collectionId}/products`,
      {
        data: { productIds },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Error removing products from collection:", error);
    throw error;
  }
};
